import { render, staticRenderFns } from "./ShortcutsModern.vue?vue&type=template&id=c7e18616"
import script from "./ShortcutsModern.vue?vue&type=script&lang=js"
export * from "./ShortcutsModern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports